import MainLayout from "@/components/layout/MainLayout.vue";
import TabClassList from "@/components/teacher/ClassList.vue";
import VideoCourseListTab from "@/components/teacher/VideoCourseListTab.vue";
import CourseList from "@/components/teacher/CourseList.vue";
import { mapGetters } from "vuex";

export default {
    name: "classListTab",
    components: {
        MainLayout,
        TabClassList,
        CourseList,
        VideoCourseListTab
    },

    data() {
        return {
            currentTab: "CourseList",
            tabs: ["CourseList", "VideoCourseList"],
            courseList:true,
            videoCourseList:false,
        };
    },

    computed: {
        currentTabComponent: function () {
            return "tab-" + this.currentTab.toLowerCase();
        },

        ...mapGetters(["teacherId", "studentId", "userType"])
    },
    
    methods: {
        setActiveTabName(name) {
            if (name == "CourseList") {
                this.videoCourseList = false;
                this.courseList = true;
            } else if (name == "VideoCourseList") {
                this.courseList = false;
                this.videoCourseList = true;
            }
        },
    },

    mounted() {
    }
};
